/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

import { ITabOption } from '~/common/interfaces/ITabOption';

import { LabelWrapper, VerticalTabMenuContainer } from './styles';
import { Typography } from '../../Typography';
import { GenericMenuItem } from '../../GenericMenuItem';

interface IVerticalTabMenuProps {
  /** array de opções do tabmenu */
  options?: ITabOption[];
  /** state selecionado no tab */
  current: string;
  /** condição para o menu conter uma borda */
  withBorder?: boolean;
  /** label do tabmenu */
  label?: string;
  /** Condição para renderizar em lagura máxima */
  fullWidth?: boolean;
  /** Condição para renderizar sem padding nas extremidades */
  withoutPadding?: boolean;
  /** Alinhamento do tabmenu vertical */
  align?: 'start' | 'center';
  /** id do label */
  labelId?: string;
  /** função de alteração que passa o key selecionado para o tabmenu */
  onChange?: (key: string) => void;
}
export const Vertical: FC<IVerticalTabMenuProps> = ({
  options,
  current,
  withBorder = true,
  fullWidth = false,
  withoutPadding = false,
  align = 'start',
  labelId,
  label,
  onChange,
}) => {
  return (
    <VerticalTabMenuContainer
      alignItems={align}
      withBorder={withBorder}
      fullWidth={fullWidth}
      withoutPadding={withoutPadding}
    >
      {label && (
        <LabelWrapper id={labelId}>
          <Typography.Subheading size="x-small" color="neutral.400">
            {label.toUpperCase()}
          </Typography.Subheading>
        </LabelWrapper>
      )}

      <ul>
        {options.map((opt, index) => (
          <GenericMenuItem
            id={opt.key}
            key={String(index)}
            index={index}
            imageUrl={opt.image}
            href={opt.href}
            icon={opt.icon}
            title={opt.title}
            selected={opt.key === current}
            withoutHoverCursor={opt.withoutHoverCursor || false}
            badge={opt.badge}
            compact={opt.compact}
            renderContent={opt.renderContent}
            onClick={() =>
              opt.optionClick ? opt.optionClick() : onChange?.(opt.key)
            }
          />
        ))}
      </ul>
    </VerticalTabMenuContainer>
  );
};
